<template>
  <div id="terms_condition">
    <div v-html="termsCondition"></div>
  </div>
</template>

<script>
export default {
  name: 'TermsConditions',

  data() {
    return {
      loading: false,
      termsCondition: null
    }
  },

  mounted() {
    this.loading = true
    this.$store
      .dispatch('setting/getTermCondition')
      .then(res => {
        this.termsCondition = res.data.value
        this.loading = false
      })
      .catch(({ message }) => {
        this.loading = false
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })
  },

  watch: {
    loading() {
      if (this.loading) {
        this.$vs.loading({
          container: '#terms_condition',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#terms_condition > .con-vs-loading')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.text-color {
  color: #646777;
}
ol {
  padding-left: 15px;
}
p {
  margin: 10px 0 0;
  font-size: 15px;
}
p > :first-child {
  margin-right: 5px;
}
div {
  font-family: 'Roboto', sans-serif;
  color: black !important;
}
</style>
